import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotGossipSection from './components/HotGossipSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '吃瓜网站线路一 - 51吃瓜网站入口与51吃瓜在线观看 | 网红塌房黑料每日大赛实时更新',
            description: '吃瓜网站线路一🔎首页，聚合51吃瓜网站入口与51吃瓜在线观看等热门通道，每日更新网红塌房黑料、🔍实时爆料追踪，一站式直达最新大瓜现场。',
            url: 'http://kp51.cn/',
            isPartOf: {
              '@type': 'WebSite',
              name: '吃瓜网站线路一',
              url: 'http://kp51.cn/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'http://kp51.cn/',
                },
              ],
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotGossipSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}